import { Guid } from "guid-typescript";

export interface WorkOrderCreationDetailsDto {
	amountInWorkOrders: number;
	amountOrdered: number;
	dateRequired: Date;
	partImage: string;
	partOrdered: string;
	salesOrderId: number;
	salesOrderLookupId: Guid;
	salesOrderPartId: number;
	workOrderLineItems: string;
}

export class WorkOrderCreationDetailsDto implements WorkOrderCreationDetailsDto {
	dateRequired = new Date;

	constructor(data?: Partial<WorkOrderCreationDetailsDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}